'use client';

import dynamic from 'next/dynamic';
import Modals from '@/home/Modals';
import { useGetIsReturnUser } from '~/context/home/GlobalContext';
import NativeError from '~/native/NativeError';

// Kept separate from the Pages Router HomeContainer on purpose. A file imported by both routers gets its
// `next/dynamic` module ids replaced by the App Router build's, so Pages Home never preloads NewUser/ReturnUser
// and React fails to hydrate it (#418).
const NewUser = dynamic(
  () => import(/* webpackChunkName: "NewUser" */ '../NewUser')
);

const ReturnUser = dynamic(
  () => import(/* webpackChunkName: "ReturnUser" */ '../ReturnUser')
);

export default function HomeContainer() {
  const isReturningUser = useGetIsReturnUser();

  return (
    <>
      <NativeError />
      {isReturningUser ? <ReturnUser /> : <NewUser />}
      <Modals />
    </>
  );
}
